import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Router } from '@angular/router'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { AccountsService, AppSignals, AuthService } from '@appShared/services'

@Component({
    selector: 'app-site-header',
    templateUrl: './site-header.component.html',
    styleUrls: ['./site-header.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class SiteHeaderComponent {
   private readonly _authService = inject(AuthService)
   private readonly _router = inject(Router)
   private readonly _accountService = inject(AccountsService)

   user = inject(AppSignals).currentUser
   routes = SITE_DIRECTORY_ROUTES

   goToSearch(): void {
      // If the previous search produced a single result, clear it so the
      // search page doesn't immediately auto-navigate to the detail page.
      if (this._accountService.accountSearchResults.value().length === 1) {
         this._accountService.clearSearch()
      }

      this._router.navigateByUrl(`/${this.routes.customerService.uri}`)
   }

   logout() {
      this._authService.logout()
   }
}
